import { AiChatFullScreenHandler } from '@/pages/AiChatFullScreen';
import React from 'react';
import { useSelector } from 'react-redux';
import * as Styles from './AiChatWrapper.styles';

export const AiChatWrapper = ({ children }) => {
  const { currentChat: currentAiChat } = useSelector(state => state.merlin);
  return (
    <div>
      {currentAiChat.fullScreen && (
        <Styles.AiWrapper $hidden={!currentAiChat.fullScreen}>
          <AiChatFullScreenHandler />
        </Styles.AiWrapper>
      )}

      <Styles.ComponentWrapper $hidden={currentAiChat.fullScreen}>
        {children}
      </Styles.ComponentWrapper>
    </div>
  );
};

export default AiChatWrapper;
